/**
 * Dashboard origin for QR deep links (phone finishes pairing).
 * Prefer VITE_DASHBOARD_PUBLIC_URL; in production derive dashboard.* from player.*.
 */
export function getDashboardPublicUrl(
  env: {
    VITE_DASHBOARD_PUBLIC_URL?: string;
    DEV?: boolean;
  } = import.meta.env,
  locationHostname: string | null = typeof window !== 'undefined' ? window.location.hostname : null,
  locationProtocol: string = typeof window !== 'undefined' ? window.location.protocol : 'https:',
): string {
  const configured = env.VITE_DASHBOARD_PUBLIC_URL?.trim().replace(/\/$/, '');
  if (configured) return configured;

  if (env.DEV) return 'http://localhost:5173';

  if (locationHostname?.startsWith('player.')) {
    const apex = locationHostname.slice('player.'.length);
    return `${locationProtocol}//dashboard.${apex}`.replace(/\/$/, '');
  }

  throw new Error(
    'VITE_DASHBOARD_PUBLIC_URL is required for production player builds (or host at player.<domain>).',
  );
}

export function buildPairDeepLink(code: string): string {
  return `${getDashboardPublicUrl()}/pair?code=${encodeURIComponent(code.trim().toUpperCase())}`;
}
